import { Drivers } from './drivers.model';
export class Vehicle {
  registration_number = '';
  make = '';
  model = '';
  type = '';
  age = '';
  colour = '';
  size = '';
}
